import { InferenceSession, Tensor } from 'onnxruntime-web';

function init() {
    // env.wasm.simd = false;
}

export async function createModelCpu(model) {
    init();
    // eslint-disable-next-line no-return-await
    return await InferenceSession.create(model, { executionProviders: ['wasm'] });
}
export async function createModelGpu(model) {
    init();
    // eslint-disable-next-line no-return-await
    return await InferenceSession.create(model, { executionProviders: ['webgl'] });
}

export async function warmupModel(model, dims) {
    // OK. we generate a random input and call Session.run() as a warmup query
    const size = dims.reduce((a, b) => a * b);
    const warmupTensor = new Tensor('float32', new Float32Array(size), dims);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < size; i++) {
        warmupTensor.data[i] = Math.random() * 2.0 - 1.0; // random value [-1.0, 1.0)
    }
    try {
        const feeds = {};
        feeds[model.inputNames[0]] = warmupTensor;
        await model.run(feeds);
    } catch (e) {
        console.error(e);
    }
}

export async function runModel(
    model,
    preprocessedData,
) {
    try {
        const feeds = {};
        feeds[model.inputNames[0]] = preprocessedData;
        const outputData = await model.run(feeds);
        const output = outputData[model.outputNames[0]];
        const condition = outputData[model.outputNames[1]];

        return [output, condition];
    } catch (e) {
        throw new Error();
    }
}
